<template>
  <formulario-base class="auto-form-wrapper" :error="error">
    <form action="#" slot="formulario">
      <div class="form-group mb-0">
        <label class="label">Correo electrónico</label>
        <div class="input-group">
          <b-form-input
            type="text"
            id="correoEntrar"
            :state="reglasEmail"
            placeholder="Correo electrónico"
            v-model="email"
            v-on:keydown="checarEmail"
            autocomplete="email"
          ></b-form-input>
          <!--<div class="input-group-append">
                <span class="input-group-text">
                    <i class="mdi mdi-check-circle-outline"></i>
                </span>
          </div>-->
        </div>
        <label class="error"></label>
      </div>
      <div class="form-group">
        <label class="label">Contraseña</label>
        <div class="input-group">
          <input
            type="password"
            id="passwordEntrar"
            class="form-control"
            placeholder="*********"
            v-model="password"
            autocomplete="current-password"
          >
          <!--<div class="input-group-append">
                    <span class="input-group-text">
                        <i class="mdi mdi-check-circle-outline"></i>
                    </span>
          </div>-->
        </div>
        <!--<label class="error">Ingresa tu contraseña - ** mensaje fijo</label>-->
      </div>
      <div class="form-group">
        <button :disabled="!botonAcceso" id ='botonEntrar' class="btn btn-primary submit-btn btn-block" @click.prevent="loginCorreo">{{textoBoton}}</button>
      </div>
      <div class="form-group d-flex justify-content-between">
        <router-link to="/registrarse" class="text-small forgot-password text-black" id="botonRegistrar">Registrate Aquí</router-link>
        <router-link
          to="/recuperar"
          class="text-small forgot-password text-black"
        >Olvidé mi contraseña</router-link>
      </div>

      <!--<div class="form-group">
            <button class="btn btn-block g-login">
                <img class="mr-3" src="../../../assets/images/file-icons/icon-google.svg" alt="">Log in with Google</button>
      </div>-->
      <!--<div class="text-block text-center my-3">
            <span class="text-small font-weight-semibold">Not a member ?</span>
            <a href="register.html" class="text-black text-small">Create new account</a>
      </div>-->
    </form>
  </formulario-base>
</template>

<script>
import FormularioBase from "./FormBase.vue";
import { mixinFormulario } from "@/mixins/mixins";
import errors from "../../errors";
import { mapActions } from "vuex";
export default {
  components: { FormularioBase },
  mixins: [mixinFormulario],
  data() {
    return {
      textoBoton: 'Entrar',
      botonAcceso: true
    }
  },
  methods: {
    ...mapActions([]),
    loginCorreo() {
      this.error = false;
      this.botonAcceso=false;
      this.textoBoton = 'Cargando . . .'
      
      this.cargandoFormulario = true;
      this.$store
        .dispatch("loginCorreo", {
          email: this.email.replace(/\s/g, ''),
          password: this.password
        })
        .then(user => {
          console.log("TCL: loginCorreo -> user", user)
          this.cargandoFormulario = false;
        })
        .catch(error => {
          console.log("TCL: loginCorreo -> error", error)
          this.cargandoFormulario = false;
          this.error = errors(error.code);
          this.textoBoton = 'Volver a intentar entrar'
          this.botonAcceso=true;
        });
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/vistas/Auth/FormLogin.vue